export default __webpack_public_path__ + "static/media/impressora-nao-fiscal.12c12d33.png";